import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/farmacovigilancia/qppv-representante-local")({
  head: () => buildRouteHead("/es/servicios/farmacovigilancia/qppv-representante-local"),
  component: PVOffering,
});

